// Componente para exibir os logos da aplicação
import React from "react";
import logoSipremo from "../../../images/sipremo.png";
import style from "../signin.module.css";

/**
 * Componente LogoSection - Exibe os logos da aplicação
 * @returns {JSX.Element} Seção com os logos
 */
const LogoSection = () => {
  return (
    <div className={style["image"]}>
      <img 
        src={logoSipremo} 
        className={style["image-image"]}
        alt="Logo Sipremo"
      />
    </div>
  );
};

export default LogoSection;

